// --- GLOBAL VARIABLES --- //
var $window = $(window);
var $document = $(document);
var $header = $(".header");
var bp_small = 771;
var bp_medium = 992;
var bp_large = 1200;
var class_active = "is-active";
var class_disabled = "is-disabled";
var class_last = "is-last";
var class_empty = "is-empty";
var class_has_error = "has-error";
var class_loading = "is-loading";
var class_opened = "is-opened";
var class_selected = "is-selected";
var class_collapse = "is-collapse";
var class_animated = "is-animated";
var $this = null;
var $containers = $("html,body");



// --- COMPONENTS, PARTS --- //
$(document).ready(function() {
	// ---  COMPONENTS --- //
	fn_components_modal();
	fn_components_select();
	fn_components_fullscreen_navigation();
	fn_components_set_image();
	fn_components_accordion();
	fn_components_slider();
	fn_components_aos();

	// ---  PARTS --- //
	fn_parts_placeholder();
	fn_parts_scroll_resize();
	fn_parts_resize();
});

var resizeTimer;

// --- SCROLL EVENT --- //
$(document).scroll(function() {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(function() {
		fn_parts_scroll_resize();
	}, 50);
});

// --- RESIZE EVENT --- //
$(window).resize(function() {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(function() {
		fn_parts_resize();
		fn_parts_scroll_resize();
	}, 50);
});

// --- LOAD EVENT --- //
$(window).bind("load", function() {
	fn_parts_dots();

	// pageLoader
	$( 'body' ).addClass( class_active );

	if ($('.js-slider-service').length){
		setTimeout(function(){ 
			$('.js-slider-service').addClass('start-animate');
		}, 100);
	}
});

